import { render, staticRenderFns } from "./DetalleIndicadorAUE.vue?vue&type=template&id=3e0448d4&scoped=true"
import script from "./DetalleIndicadorAUE.vue?vue&type=script&lang=js"
export * from "./DetalleIndicadorAUE.vue?vue&type=script&lang=js"
import style0 from "./DetalleIndicadorAUE.vue?vue&type=style&index=0&id=3e0448d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0448d4",
  null
  
)

export default component.exports